export enum AccountType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

export interface ChartOfAccount {
  id: string;
  accountCode: string;
  name: string;
  type: AccountType;
  parentId?: string;
  journalEntry: boolean;
  isActive: boolean;
  isDeleted: boolean;
  deletedAt?: Date;
  createdBy?: string;
  updatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ChartOfAccountFormData {
  accountCode: string;
  name: string;
  type: AccountType;
  parentId?: string;
  journalEntry: boolean;
  isActive: boolean;
  createdBy?: string;
  updatedBy?: string;
}

export interface ChartOfAccountListResponse {
  data: ChartOfAccount[];
  total: number;
  page: number;
  limit: number;
}

export interface ChartOfAccountFilterParams {
  skip?: number;
  take?: number;
  search?: string;
  type?: AccountType;
  isActive?: boolean;
  journalEntry?: boolean;
}
